import React, { useState, ReactNode, FC } from 'react';
import { IntlProvider } from 'react-intl';
import { LANGUAGES } from './commons/constants';
import AppLocale from './lngProvider';

type IntlContextType = {
  locale?: string;
  setLocale?: (language: string) => void;
};

export const IntlContext = React.createContext<IntlContextType>({});

type IntlProviderWrapperPropsType = {
  children?: ReactNode;
};

const IntlProviderWrapper: FC<IntlProviderWrapperPropsType> = (props) => {
  const { children } = props;
  const [locale, setLocale] = useState<string>(LANGUAGES.vi.key);

  const currentAppLocale = AppLocale[locale];
  return (
    <IntlContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  );
};

export default IntlProviderWrapper;
